import React from 'react';
import { cn } from "@/lib/utils";
import { Button } from './button';

function EmptyState({ icon: Icon, title, description, action, actionLabel, className }) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-12 text-center", className)}>
      {Icon && <Icon className="h-10 w-10 text-muted-foreground/50 mb-4" />}
      {title && <h3 className="text-sm font-medium text-foreground mb-1">{title}</h3>}
      {description && <p className="text-sm text-muted-foreground max-w-sm">{description}</p>}
      {action && actionLabel && (
        <Button variant="outline" size="sm" onClick={action} className="mt-4">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

export { EmptyState }
